// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export var EventDataType = "EventData";
export var ExceptionDataType = "ExceptionData";
export var MetricDataType = "MetricData";
export var PageViewDataType = "PageviewData";
export var PageViewPerformanceDataType = "PageviewPerformanceData";
export var RemoteDependencyDataType = "RemoteDependencyData";
export var RequestDataType = "RequestData";
export var TraceDataType = "MessageData";
//# sourceMappingURL=DataTypes.js.map